import type { AttractionCategory } from '../types'

export const CATEGORY_LABEL: Record<AttractionCategory, string> = {
  volcano: 'Volcano',
  lake: 'Lake',
  waterfall: 'Waterfall',
  thermal: 'Thermal',
  forest: 'Forest',
  canopy: 'Canopy',
  cave: 'Cave',
  wildlife: 'Wildlife',
  culture: 'Culture',
  viewpoint: 'Viewpoint',
  infrastructure: 'Infrastructure',
  park: 'Park',
  farm: 'Farm',
  'water-activity': 'On the water',
}

/**
 * Marker tint per category so the skyline reads as a legend rather than a field
 * of identical pins. At 90 m per world unit a physically scaled marker would be
 * sub-pixel, so these are symbolic beacons, not objects.
 */
export const CATEGORY_COLOR: Record<AttractionCategory, number> = {
  volcano: 0xd2603f,
  lake: 0x5fb6d4,
  waterfall: 0x8ad6e8,
  thermal: 0xe08a52,
  forest: 0x5ea662,
  canopy: 0x79c47c,
  cave: 0x9a8bbf,
  wildlife: 0xd9b34a,
  culture: 0xd98cae,
  viewpoint: 0xf0c27a,
  infrastructure: 0xa8b0b8,
  park: 0x4f9e6a,
  farm: 0xcbb45e,
  'water-activity': 0x6fc6c0,
}

export const SETTLEMENT_COLOR = 0xf0c27a
